export const ContributorGroupType = {
  COMMERCIAL_PROJECT_MANAGER: 'commercialProjectManager',
  ENGINEER: 'engineer',
  EXPORT_CONTROL: 'exportControl',
  LEGAL: 'legal',
  NA: 'na',
  OTHER: 'other',
  QS: 'qs',
  SALES: 'sales',
  PROCUREMENT_OFFICER: 'procurementOfficer',
  TEAM_ASSISTANT: 'teamAssistant',
  TECHNICAL_PROJECT_MANAGER: 'technicalProjectManager',
  LOGISTIC: 'logistic',
  LICENSE_MANAGER: 'licenseManager',
}
